export default "__VITE_ASSET__fa983097__"